import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { API_URLS, stripeConfig } from './config';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import './Checkout.css';
import fetchWithAuth from './api';

const stripePromise = loadStripe(stripeConfig.Stripe_Key);

const Checkout = ({ user, userPermissions }) => {
  const location = useLocation();
  const { priceId } = location.state || {};

  const fetchClientSecret = useCallback(() => {
    return fetchWithAuth(API_URLS.STRIPE_CREATE_CHECKOUT_SESSION, user, userPermissions, {
      method: 'POST',
      body: JSON.stringify({
        PriceId: priceId
      })
    })
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, [user, userPermissions, priceId]);

  const options = { fetchClientSecret };

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default Checkout;
